import { LinkButton, UIHeading1, UIHeading3, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './JournalHighlightsSection.css';

export function JournalHighlightsSection({ children }: React.PropsWithChildren<{}>) {
  const deviceType = useDeviceType();
  const HeadingComponent = deviceType === 'desktop' ? UIHeading1 : UIHeading3;

  return (
    <section className={styles['section']} data-name="JournalHighlights">
      <div className={styles['section-heading']}>
        <HeadingComponent as="span">Полезное от Циан.Журнала</HeadingComponent>
        <LinkButton size="XS" theme="fill_white_primary" href="https://www.cian.ru/magazine/" target="_blank">
          Циан Журнал
        </LinkButton>
      </div>

      {children}
    </section>
  );
}
